import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { EMPTY, IN_PROGRESS, DONE, ERROR } from "constants/Status";
import { LabelsActionsCreator } from "actions/labelsActionsCreator";
import { GET_LABELS_SUCCESS } from "actions/labelsActions";
import { get } from "lodash";
import { getLabels } from "selectors/labels";
import { PayableType } from "types/payable";


export interface IUseLabels {
    loadLabels: (clientId: string, instanceId: string, domain: string, realm: string, language: string, payableTypeDefinitions: PayableType[], payableUi:string) => Promise<void>;
    getLabels: any;
    status: string;
}

const useLabels = (): IUseLabels => {
    const dispatch = useDispatch();
    const labels = useSelector(getLabels);
    const [status, setStatus] = useState(EMPTY);

    const loadLabels = async (clientId: string, instanceId: string, domain: string, realm: string, language: string, payableTypeDefinitions: PayableType[], payableUi: string) => {
        setStatus(IN_PROGRESS);
        try {
            await new Promise((resolve, reject) => {
                dispatch(
                    LabelsActionsCreator.getLabels(clientId, instanceId, domain, realm, language, payableTypeDefinitions, payableUi, resolve, reject)
                );
            });
            setStatus(DONE);
        } catch (error) {
            setStatus(ERROR);
        }
    };

    return {
        loadLabels,
        getLabels: () => labels,
        status,
    };
};

export default useLabels;